export default "__VITE_PUBLIC_ASSET__12d5f6c0__"